import React, { useState, useEffect } from 'react';
import { Layout, Dropdown } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import AdminSidebar from '../Admin/AdminSidebar/AdminSidebar';
import userIcon from '@Assets/images/user.png';
import axios from 'axios';
import swal from 'sweetalert';
import { API_URL } from '../BaseUrlApi/Url';

const { Header, Content } = Layout;

const headers = {
  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  'Content-Type': 'application/json',
};

const AdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    let adminName = localStorage.getItem('admin_name');
    setAdmin(adminName);
  }, []);

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logout = () => {
    swal({
      title: 'LOG OUT',
      text: 'Apakah anda yakin ingin Log Out dari aplikasi ini ?',
      buttons: ['Tidak', 'Ya'],
      dangerMode: true,
    }).then((removeData) => {
      if (removeData) {
        const logOutResponse = async () => {
          await axios.post(`${API_URL}/auth/logout`, [], { headers });
          localStorage.clear();
          window.location.href = '/login';
        };
        logOutResponse();
      }
    });
  };

  const userMenu = {
    items: [
      {
        key: '1',
        label: (
          <div onClick={logout}>
            Logout
          </div>
        ),
      },
    ],
  };

  return (
    <Layout hasSider style={{ minHeight: '100vh', display: 'flex', flexDirection: 'row', width: '100%' }}>
      <AdminSidebar collapsed={collapsed} />
      <Layout className="site-layout" style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Header className="adm-navbar" style={{ padding: 0, background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <FontAwesomeIcon
              icon={collapsed ? faBars : faAngleLeft}
              className="open-icon"
              onClick={toggle}
              style={{ cursor: 'pointer', padding: '0 24px', fontSize: '1.5rem', color: '#039beb' }}
            />
          </div>
          <div style={{ marginRight: '24px' }}>
             <Dropdown menu={userMenu} trigger={['click']}>
              <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <span className="admin-name" style={{ marginRight: '10px', fontWeight: 'bold' }}>{admin}</span>
                <img src={userIcon} className="user-icon" alt="" style={{ width: '35px', height: '35px', borderRadius: '50%' }} />
              </span>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ margin: '0', overflow: 'initial' }}>
          <div className="admin-overlay" style={{ minHeight: 'calc(100vh - 64px)', padding: '24px' }}>
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
